import { useTranslation } from "react-i18next";
import emptyImg from "@/assets/empty.png";
import { Button } from "@/comps/Button";

export const FailResult = ({ onReload }: { onReload?: () => void }) => {
  const { t } = useTranslation();

  return (
    <div className="px-6">
      <div className="h-[400px] rounded-xl bg-white pt-6">
        <img src={emptyImg} className="m-auto h-[150px] w-[200px]" alt="" />
        <div className="text-center leading-6">
          <span>{t("fetch_error")}</span>
          <div className="mt-6">
            <Button btnType="outline" onPress={onReload} className="w-30">
              {t("reload")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
